module.exports = __webpack_public_path__ + "img/白鲜皮.9d6f0775.jpg";